import { Link } from 'react-router-dom'

/**
 * "Create a Request" CTA — the most prominent action on the USER+
 * dashboard surface. Targets `/requests-center/catalog`.
 *
 * Spec 4 / Group 9d — "Create CTA is the most prominent action".
 */
export function CreateCtaButton() {
	return (
		<Link
			to="/requests-center/catalog"
			className="inline-flex items-center rounded-md bg-foreground px-5 py-2 text-sm font-medium text-white hover:bg-foreground/90"
		>
			Create a Request
		</Link>
	)
}
